import { collection, doc, getDoc, getDocs, serverTimestamp, Timestamp, writeBatch } from 'firebase/firestore';
import { db } from '@/config/firebase';
import type { ResultadoImportacao } from './guardioesCsv';

/** Guardião dos Dados: quem concluiu o treinamento com aproveitamento (≥ 80%). Doc id = e-mail.
 * Sem nota e sem ranking de propósito — só quem é e desde quando. Vale pra sempre. */
export interface Guardiao {
  email: string;
  nome: string;
  colaboradorId: string | null;
  aprovadoEm: Timestamp | null;
  codigo: string | null;
}

const COLECAO = 'si_guardioes';
/** Controle da última importação do CSV (só o SI vê). */
const ULTIMA_IMPORTACAO = doc(db, 'si_config_guardioes', 'ultimaImportacao');

export interface UltimaImportacaoGuardioes {
  em: Timestamp | null;
  por: { id: string; name: string } | null;
  arquivo: string | null;
  novos: number;
}

export const guardioesService = {
  async listar(): Promise<Guardiao[]> {
    const snap = await getDocs(collection(db, COLECAO));
    return snap.docs.map((d) => ({ email: d.id, ...(d.data() as Omit<Guardiao, 'email'>) }));
  },

  async ultimaImportacao(): Promise<UltimaImportacaoGuardioes | null> {
    const snap = await getDoc(ULTIMA_IMPORTACAO);
    return snap.exists() ? (snap.data() as UltimaImportacaoGuardioes) : null;
  },

  /** Grava só os "novos" (quem já é Guardião não muda — a data de aprovação fica a primeira) e
   * registra a importação (mesmo sem ninguém novo). */
  async importar(novos: ResultadoImportacao[], por: { id: string; name: string }, arquivo: string): Promise<number> {
    const validos = novos.filter((n) => n.situacao === 'novo' && n.email && n.colaborador);
    if (validos.length === 0) {
      const lote = writeBatch(db);
      lote.set(ULTIMA_IMPORTACAO, { em: serverTimestamp(), por, arquivo, novos: 0 });
      await lote.commit();
    }
    for (let i = 0; i < validos.length; i += 400) {
      const lote = writeBatch(db);
      for (const n of validos.slice(i, i + 400)) {
        lote.set(doc(db, COLECAO, n.email as string), {
          nome: n.nome,
          colaboradorId: n.colaborador!.id,
          aprovadoEm: n.aprovadoEm ? Timestamp.fromMillis(n.aprovadoEm) : null,
          codigo: n.codigo,
          importadoEm: serverTimestamp(),
          importadoPor: por,
        });
      }
      if (i + 400 >= validos.length) lote.set(ULTIMA_IMPORTACAO, { em: serverTimestamp(), por, arquivo, novos: validos.length });
      await lote.commit();
    }
    return validos.length;
  },
};
